// services/abandonedCartService/config.ts - services/abandonedCartService.ts split (sub-module config)

import { getApiUrl } from '../apiConfig.js';


export const API_BASE = getApiUrl();


export const API_KEY = import.meta.env.VITE_VPS_API_KEY || '';


export const FALLBACK_ENABLED = true;
